export default __webpack_public_path__ + "static/media/holiday-inn.82c5a35a.svg";